<form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate [attr.aria-busy]="saving">
    <div class="row">
        <div class="col-md-6 mb-3">
            <label class="form-label" [for]="idPrefix + '-name'">
                Name @if (!readOnly) { <span class="text-red" aria-hidden="true">*</span><span class="visually-hidden">(required)</span> }
            </label>
            <input type="text" class="form-control" [id]="idPrefix + '-name'" formControlName="name"
                   [class.is-invalid]="showError('name')"
                   [attr.aria-required]="!readOnly"
                   [attr.aria-invalid]="showError('name')"
                   [attr.aria-describedby]="describedBy('name')"
                   data-testid="organisation-name">
            @if (showError('name')) {
                <div class="field-error" role="alert" [id]="idPrefix + '-name-error'">
                    @if (form.controls.name.hasError('required')) { Name is required. }
                    @else { Name must be {{ nameMaxLength }} characters or fewer. }
                </div>
            }
        </div>

        <div class="col-md-6 mb-3">
            <label class="form-label" [for]="idPrefix + '-code'">
                Code @if (!readOnly && !codeReadOnly) { <span class="text-red" aria-hidden="true">*</span><span class="visually-hidden">(required)</span> }
            </label>
            <div class="input-group" [class.has-validation]="showError('code')">
                @if (codePrefix) {
                    <span class="input-group-text organisation-code-prefix" [id]="idPrefix + '-code-prefix'"
                          data-testid="organisation-code-prefix">{{ codePrefix }}</span>
                }
                <input type="text" class="form-control" [id]="idPrefix + '-code'" formControlName="code"
                       [attr.maxlength]="codeMaxLength"
                       [class.is-invalid]="showError('code')"
                       [attr.aria-required]="!readOnly && !codeReadOnly"
                       [attr.aria-invalid]="showError('code')"
                       [attr.aria-describedby]="codeDescribedBy()"
                       data-testid="organisation-code">
            </div>
            @if (showError('code')) {
                <div class="field-error" role="alert" [id]="idPrefix + '-code-error'" data-testid="organisation-code-error">
                    @if (serverCodeError) { {{ serverCodeError }} }
                    @else if (form.controls.code.hasError('required')) { Code is required. }
                    @else { Code must be {{ codeMaxLength }} characters or fewer. }
                </div>
            }
        </div>

        <div class="col-md-6 mb-3">
            <label class="form-label" [for]="idPrefix + '-address'">Address</label>
            <input type="text" class="form-control" [id]="idPrefix + '-address'" formControlName="address"
                   [class.is-invalid]="showError('address')"
                   [attr.aria-invalid]="showError('address')"
                   [attr.aria-describedby]="describedBy('address')"
                   data-testid="organisation-address">
            @if (showError('address')) {
                <div class="field-error" role="alert" [id]="idPrefix + '-address-error'">
                    Address must be {{ addressMaxLength }} characters or fewer.
                </div>
            }
        </div>

        <div class="col-md-6 mb-3">
            <label class="form-label" [for]="idPrefix + '-city'">City</label>
            <input type="text" class="form-control" [id]="idPrefix + '-city'" formControlName="city"
                   [class.is-invalid]="showError('city')"
                   [attr.aria-invalid]="showError('city')"
                   [attr.aria-describedby]="describedBy('city')"
                   data-testid="organisation-city">
            @if (showError('city')) {
                <div class="field-error" role="alert" [id]="idPrefix + '-city-error'">
                    City must be {{ cityMaxLength }} characters or fewer.
                </div>
            }
        </div>

        <div class="col-md-6 mb-3">
            <label class="form-label" [for]="idPrefix + '-postcode'">Postcode</label>
            <input type="text" class="form-control" [id]="idPrefix + '-postcode'" formControlName="postcode"
                   [class.is-invalid]="showError('postcode')"
                   [attr.aria-invalid]="showError('postcode')"
                   [attr.aria-describedby]="describedBy('postcode')"
                   data-testid="organisation-postcode">
            @if (showError('postcode')) {
                <div class="field-error" role="alert" [id]="idPrefix + '-postcode-error'">
                    Postcode must be {{ postcodeMaxLength }} characters or fewer.
                </div>
            }
        </div>
    </div>

    <div class="organisation-form-actions">
        <div class="organisation-form-actions-extra">
            <ng-content></ng-content>
        </div>
        @if (!readOnly) {
            <button type="submit" class="btn btn-success" [disabled]="!canSave" [attr.aria-busy]="saving"
                    data-testid="organisation-save-btn">
                <i class="bi bi-floppy me-2" aria-hidden="true"></i>Save
            </button>
            <span class="visually-hidden" role="status" aria-live="polite">{{ saving ? 'Saving organisation' : '' }}</span>
        }
    </div>
</form>
